import { useEffect } from "react";

type Props = {
  visible: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

export default function GpsToast({ visible, onClose, onConfirm }: Props) {
  useEffect(() => {
    if (visible) {
      const timeout = setTimeout(onClose, 8000); // auto-fermeture après 5s
      return () => clearTimeout(timeout);
    }
  }, [visible, onClose]);

  if (!visible) return null;

  return (
    <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-50 bg-yellow-100 border border-yellow-400 text-yellow-800 px-4 py-3 rounded-lg shadow-md w-[90%] max-w-md animate-slide-up">
      <p className="mb-2 text-sm font-medium">
        La géolocalisation semble désactivée.
      </p>
      <div className="flex justify-end gap-3">
        <button
          onClick={onClose}
          className="text-sm px-3 py-1 bg-gray-200 rounded hover:bg-gray-300"
        >
          Fermer
        </button>
        <button
          onClick={onConfirm}
          className="text-sm px-3 py-1 bg-blue-600 text-white rounded hover:bg-blue-700"
        >
          Activer dans les paramètres
        </button>
      </div>
    </div>
  );
}